import React, { FunctionComponent } from 'react';
import { IBindingAction, IBindingCallback1 } from '../../common/models/callback';
import Tooltip from '../Tooltip';
import { IFormattedMessage } from '../../common/models/common/IFormattedMessage';
import styles from './styles.module.scss';
import { FormattedMessage } from 'react-intl';
import { is } from 'ramda';
import { concat } from '../../common/helpers/arrayHelper';

interface IProps {
  icon: JSX.Element;
  onClick?: IBindingAction | IBindingCallback1<React.MouseEvent<HTMLButtonElement, MouseEvent>>;
  variant?: 'primary' | 'blue' | 'bordered';
  size?: 'sm'| 'lg';
  disabled?: boolean;
  enableAction?: boolean;
  tooltip?: IFormattedMessage | string;
}

const IconButton: FunctionComponent<IProps> = ({
  icon,
  onClick,
  variant = 'primary',
  size = 'sm',
  disabled,
  enableAction,
  tooltip
}) => {
  const button = (
    <button
      className={concat(
        styles.btn,
        styles[variant],
        styles[size],
        disabled && styles.disabled,
        !enableAction && disabled && styles.withoutAction,
        'icon-button'
      )}
      type="button"
      onClick={(Boolean(disabled) && !enableAction) ? undefined : onClick}
    >
      <span>{icon}</span>
    </button>
  );

  return tooltip
    ? (
      <Tooltip
        className={styles.tooltip}
        content={is(String, tooltip) ? tooltip as string : <FormattedMessage {...tooltip as IFormattedMessage} />}
      >
        {button}
      </Tooltip>
    )
    : button;
};

export default IconButton;
